import { useEffect, useRef, useState, type ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { calendarApi, homeQuery } from '../../lib/calendar-api';
import homeStyles from '../../routes/app/Home.module.css';
import { Icon } from '../ui/Icon';
import { EmailDemo } from './MailSurface';
import styles from './GmailPreferences.module.css';

export function ReplyOnboarding({ children }: { children?: ReactNode }) {
  const home = useQuery(homeQuery());
  const [showIntro, setShowIntro] = useState<boolean | undefined>();
  const acknowledged = useRef(false);
  useEffect(() => {
    if (showIntro === undefined && home.data)
      setShowIntro(!home.data.preferences.homeIntroSeenAt);
  }, [home.data, showIntro]);
  useEffect(() => {
    if (!showIntro || acknowledged.current) return;
    acknowledged.current = true;
    void calendarApi.preferences({ introSeen: true }).catch(() => {});
  }, [showIntro]);
  if (!showIntro) return <>{children}</>;
  return (
    <>
      <section
        className={`${styles.onboarding} ${styles.homeIntro}`}
        aria-label="Welcome to Resonance"
      >
        <header className={styles.homeIntroHeader}>
          <span className={styles.introBadge}>
            <Icon name="sparkles" size={13} />
            INTRODUCTION
          </span>
          <h2>Welcome to Resonance</h2>
          <p>Review replies. Move your goals forward. Chat with Echo.</p>
        </header>
        <div className={styles.introExamples}>
          <EmailDemo />
        </div>
        <div className={`${styles.makeItYours} ${homeStyles.mission}`}>
          <h3 className={styles.progressTitle}>
            A partner that learns your business.
          </h3>
          <p className={styles.progressDescription}>
            As you use Resonance, Echo gets to know your goals, thinks ahead,
            and takes the next steps for you.
          </p>

        </div>
      </section>
      {children}
    </>
  );
}
